// Game configuration for beginner level phonemes
// This should ideally be stored in backend/database, but for now we'll use a static config

export const BEGINNER_PHONEMES = new Set([
  // Simple vowels
  'ə',  // schwa
  'aː', // long a

  // Basic unaspirated consonants
  'k',  // ka
  'g',  // ga
  'p',  // pa
  'b',  // ba

  // Common nasals
  'm',  // ma
  'n',  // na

  // Simple consonants
  'l',  // la
  's',  // sa
  'h',  // ha
]);

// This can be updated by admin dashboard in the future
export const getBeginnerPhonemes = (): Set<string> => {
  // In production, this would fetch from backend/localStorage
  return BEGINNER_PHONEMES;
};